import { connect } from "react-redux";
import {
	searchInterest,
	getInterestMatches,
} from "ducks/discovery";

import InterestSearch from "apps/discovery/components/headers/InterestSearch";

function mapStateToProps(state) {
	return {
		interestResults: state.discovery.interestResults,
		isSearchingInterest: state.discovery.isSearchingInterest,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		searchInterest(section) {
			dispatch(searchInterest(section));
		},

		getInterestMatches(interestId) {
			dispatch(getInterestMatches(interestId));
		},
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(InterestSearch);



// WEBPACK FOOTER //
// ./src/apps/discovery/containers/headers/InterestSearch.jsx